<template>
  <div id="order-wrapper" >
    <!--begin --- header ---begin  -->
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text"><span class="title-tip"></span>储运发运</span>
      </div>
      <div class="h-button-warpper">
        <el-button size="small" @click="save" type="primary">发送</el-button>
        <el-button size="small" @click="reset()" type="primary">重置</el-button>
      </div>
    </div>
    <!--end --- header ---end  -->
    <!--begin --- content ---begin  -->
    <div class="white-bg-radius sys-content w-label" id="orderCheck">
        <el-form :model="ruleForm" :rules="rules" ref="form"
                  label-position="right" label-width="100px" class="demo-ruleForm">
          <el-form-item label="起讫日期：" prop="orderDate">
            <el-date-picker
              v-model="ruleForm.orderDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              placeholder="请选择起讫日期"
              
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item label=" " >
              <el-button size="small" @click="add" type="primary">新增</el-button>
          </el-form-item>
          <div class="tabWarp" style="padding-left:100px;width:400px">
            <el-table  :data="ruleForm.list" border>
              <el-table-column
                prop="ruleForm.list.validNo"
                label="销售订单号"
                align="center"
                width="200">
                <template slot-scope="{column,row,$index}" >
                  <el-input v-model="ruleForm.list[$index]" ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="date"
                label="操作"
                align="center"
                >
                <template slot-scope="{column,row,$index}"><el-button size="mini" @click="remove($index)" type="primary">删除</el-button></template>
              </el-table-column>
            </el-table>
          </div>
          <div class="tabWarp">
            <label style="min-width:100px;">
              返回结果：
            </label>
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows:8}" v-model="ruleForm.remark">
            </el-input>
          </div>
        </el-form>
    </div>
  </div>

</template>
<script>
  import { mapGetters } from 'vuex';
  import { methodPost } from "../../api/request.js";
  export default {
    name: 'transport',
    data() {
      return {
        ruleForm: {
          disabled: false,
          orderDate: '',
          status: 1,
          remark: '',
          list: ['']
        },
        rules: {
          orderDate: [
            { required: false, message: '此项为必填项', trigger: 'blur' }
          ]
  
        }

      }
    },
    methods: {
      reset() {
        this.ruleForm.orderDate = '';
        this.ruleForm.list = ['']
        this.ruleForm.remark = '';
      },
      save() {
        // if (this.ruleForm.orderDate.length === 0 && this.ruleForm.list[0] === '') {
        //   this.$message.error('请填写起讫日期或销售订单号任选一项')
        //   return false
        // } else {
        //   this.submitForm()
        // }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitForm()
          } else {
            console.log('error submit!!')
          }
        })
      },
      submitForm() {
        const URL = '/material/syncPodBack'
        const params = {
          startDate: this.ruleForm.orderDate[0],
          endDate: this.ruleForm.orderDate[1],
          vbelns: this.ruleForm.list
        }
        methodPost(URL, params).then(res => {
          if (res.code === 0) {
            this.ruleForm.remark = res.data;
          } else {
            this.$message.error(res.message || '发送出错，请稍后再试')
          }
        })
      },
      // 添加
      add() {
        this.ruleForm.list.push('')
      },
      // 删除
      remove(index) {
        this.ruleForm.list.splice(index, 1)
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ])
    },
    mounted() {

    }

  }
</script>
<style lang="scss" scoped>
 .sys-content{
   padding:20px;
 }
.tabWarp{
  padding:20px 0 0;
  display:flex;
  width:600px;
  .el-input{
    width:178px!important;
    margin:5px 0!important;
  }
  label{
    color: #606266;
    font-size: 12px;
    text-align:right;
  }
}
</style>
<style lang="scss">
#orderCheck {
  .el-form-item .el-form-item__error{
    left: 125%;
  }
  .el-range-editor--medium .el-range-input{
    height:20px!important;
  }
  .el-range-editor--medium.el-input__inner{
    height:22px!important;
    line-height:22px!important;
  }
  .el-range-editor--medium .el-range-separator{
    line-height:22px!important;
    height:22px!important;
  }
  .el-date-editor--daterange.el-input, 
  .el-date-editor--daterange.el-input__inner, 
  .el-date-editor--timerange.el-input, 
  .el-date-editor--timerange.el-input__inner{
      width:220px!important;
      border: 1px solid #DCDFE6;
  }
  .el-form-item.is-success .el-input__inner{
    border:1px solid #4097d9;
  }
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/orderCheck/transport.vue